import { RecoilRoot } from "recoil";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "index.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import MainNav from "components/MainNav";
import AddressSearch from "views/AddressSearch";
import CustomerInfoKickoutPage from "views/CustomerInfoKickoutPage";
import ServiceRequest from "views/ServiceRequest";
import ServiceRequestConfirmation from "views/ServiceRequestConfirmation";
import Browse from "views/Browse";
import Customize from "views/Customize";
import Footer from "components/Footer";
import Overlay from "components/Overlay";
import Toaster from "components/Toaster";
import Banner from "components/Browse/Banner";
import RateChangeBanner from "components/Browse/RateChangeBanner";
import CookieDisclosure from "components/CookieDisclosure";
import Checkout from "views/Checkout";
import Confirm from "views/Confirm";
import ThankYouKickout from "views/ThankYouKickout";
import Schedule from "views/Schedule";
import Payment from "views/Payment";
import ThankYou from "views/ThankYou";
import CustomerSummary from "views/CustomerSummary";
import RestoreCartError from "views/RestoreCartError";
import Ekick from "views/ekick";
import CustomerAuth from "views/CustomerAuth";
import Marketing from "views/Marketing";
import Cancel from "views/Cancel";
import Sorry from "views/Sorry";
import NotFound from "views/NotFound";
import { PATH } from "utils/const";

function App() {
  return (
    <div className="App app-container">
      <CookieDisclosure />
      <RecoilRoot>
        <Router>
          <Toaster />
          <MainNav />
          <Overlay />
          <Banner />
          <RateChangeBanner />
          <div className="container d-flex justify-content-center mt-5">
            <Routes>
              <Route path={PATH.ROOT} element={<Navigate to={PATH.ADDRESS_SEARCH} />} />
              <Route path={PATH.ADDRESS_SEARCH} element={<AddressSearch />} />
              <Route path={PATH.BROWSE} element={<Browse />} />
              <Route path={PATH.CUSTOMER_INFO_K} element={<CustomerInfoKickoutPage />} />
              <Route path={PATH.SERVICE_REQUEST} element={<ServiceRequest />} />
              <Route path={PATH.SERVICE_REQUEST_CONF} element={<ServiceRequestConfirmation />} />
              <Route path={PATH.CUSTOMIZE} element={<Customize />} />
              <Route path={PATH.CHECKOUT} element={<Checkout />} />
              <Route path={PATH.CONFIRM} element={<Confirm />} />
              <Route path={PATH.THANK_YOU_K} element={<ThankYouKickout />} />
              <Route path={PATH.SCHEDULE} element={<Schedule />} />
              <Route path={PATH.PAYMENT} element={<Payment />} />
              <Route path={PATH.THANK_YOU} element={<ThankYou />} />
              <Route path={PATH.E_KICK} element={<Ekick />} />
              <Route path={PATH.RESTORE_CART_ERROR} element={<RestoreCartError />} />
              <Route path={PATH.MARKETING} element={<Marketing />} />
              <Route path={PATH.CANCEL} element={<Cancel />} />
              <Route path={PATH.SORRY} element={<Sorry />} />
              <Route path={PATH.NOT_FOUND} element={<NotFound />} />
            </Routes>
          </div>
          <div className="container d-flex justify-content-center mt-5" style={{ width: "100%", maxWidth: "1800px" }}>
            <Routes>
              <Route path={PATH.CUSTOMER_SUMMARY} element={<CustomerSummary />} />
              <Route path={PATH.AUTH} element={<CustomerAuth />} />
            </Routes>
          </div>
        </Router>
        <Footer />
      </RecoilRoot>
    </div>
  );
}

export default App;
